/**
    * Return a hierarchical object from a flat object, expanding dot notation keys
    * e.g. {"Class.Property": "value"} => {Class: {Property: "value"}}
*/
export default function expandDotNotation(formData: object) {
  const result = {};
  Object.entries(formData).forEach(([key, value]) => {
    addProperty(result, key, value);
  });
  return result;
}

function addProperty(target: any, key: string, value: any) {
  if (key.includes('.')) {
    const keys = key.split('.');
    let currentTarget = target;
    for (let i = 0; i < keys.length - 1; i += 1) {
      if (!currentTarget[keys[i]]) {
        currentTarget[keys[i]] = {};
      }
      currentTarget = currentTarget[keys[i]];
    }
    currentTarget[keys[keys.length - 1]] = value;
  } else {
    target[key] = value;
  }
}
